import { render, staticRenderFns } from "./OrganizationViewLogs.vue?vue&type=template&id=3287df2c&"
import script from "./OrganizationViewLogs.vue?vue&type=script&lang=js&"
export * from "./OrganizationViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports